<template>
  <div class="col table-responsive">
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th scope="col" class="multi-line-header">Produktionsdatum</th>
          <th scope="col" class="multi-line-header">Operator</th>
          <th scope="col" class="multi-line-header">Glasbatch</th>
          <th scope="col" class="multi-line-header">Glas Produktionsdatum</th>
          <th scope="col" class="multi-line-header">Glas Material</th>
          <th scope="col" class="multi-line-header">Glas ist gehärtet</th>
          <th scope="col" class="multi-line-header">Palette ist offen</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(entry, tableId) in entries" :key="tableId">
          <td>{{ entry.dateinproduction.replace("T", " ") }}</td>
          <td>{{ entry.firstname }} {{ entry.lastname }}</td>
          <td>{{ entry.glassbatch }}</td>
          <td>{{ entry.productiondate.split("T")[0] }}</td>
          <td>{{ entry.name }}</td>
          <td v-if="entry.ishardeningpass">Ja</td>
          <td v-else>Nein</td>
          <td v-if="entry.ispaletteopened">Ja</td>
          <td v-else>Nein</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted } from "vue";
import { instance as axios } from "@/services/axios";

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
});

const entries = ref([]);

const fetchData = async (url) => {
  try {
    const { data } = await axios.get(url);
    entries.value = data;
  } catch (error) {
    console.log(error.message);
  }
};

onMounted(() => {
  fetchData(props.url);
});
</script>

<style scoped>
@media (max-width: 768px) {
  th {
    white-space: normal;
    word-wrap: break-word;
  }
}
</style>
